export default {
  '-1': 'Draft',
  '0': 'In Approval',
  '1': 'Approved',
  '2': 'Active',
  '3': 'Matured',
  '4': 'Cancelled',
}